// Module
var code = `<dialog class="jumbotron-dialog" jumbotron-dialog="\$ctrl.report" jumbotron-dialog-close="\$ctrl.close()"
  aria-labelledby="preflight-report-heading">
  <div class="jumbotron-panel-head">
    <h2 class="jumbotron-heading" id="preflight-report-heading">{{ \$ctrl.heading }}</h2>
    <button type="button" class="btn-close" ng-click="\$ctrl.close()" aria-label="Close"></button>
  </div>

  <div class="jumbotron-dialog-body">
    <div class="jumbotron-note preflight-note" ng-if="\$ctrl.isLoading">Checking the plan…</div>

    <div class="jumbotron-note-box is-bad" ng-if="\$ctrl.errorText">{{ \$ctrl.errorText }}</div>

    <div class="jumbotron-note-box is-ok preflight-clear" ng-if="\$ctrl.isClear">
      <i class="fas fa-check" aria-hidden="true"></i>
      <div class="preflight-clear-text">
        <div>Everything scheduled reaches the screen.</div>
      </div>
    </div>

    <div class="preflight-scene" ng-repeat="group in \$ctrl.groups">
      <div class="jumbotron-kind-label preflight-scene-name" ng-if="group.sceneName !== \$ctrl.sceneName">{{ group.sceneName }}</div>

      <div class="jumbotron-note-box preflight-casualty" ng-repeat="stretch in group.undefinedStretches">
        <i class="fas fa-circle-question" aria-hidden="true"></i>
        <div class="preflight-casualty-text">
          <div class="preflight-headline">{{ stretch.headline }}</div>
          <div class="preflight-cause">{{ stretch.cause }}</div>
          <div class="jumbotron-note preflight-remedy">
            <i class="fas fa-wrench" aria-hidden="true"></i>
            <span>{{ stretch.remedy }}</span>
          </div>
        </div>
      </div>

      <div class="jumbotron-note-box preflight-casualty is-openable" ng-repeat="casualty in group.casualties"
        role="button" tabindex="0" title="Open this interval"
        ng-click="\$ctrl.open(casualty)"
        ng-keydown="\$ctrl.openOnKey(\$event, casualty)"
        ng-mouseenter="\$ctrl.highlight(casualty.intervalId)" ng-mouseleave="\$ctrl.clearHighlight()"
        ng-focus="\$ctrl.highlight(casualty.intervalId)" ng-blur="\$ctrl.clearHighlight()">
        <i class="fas fa-triangle-exclamation" aria-hidden="true"></i>
        <div class="preflight-casualty-text">
          <div class="preflight-headline">
            <strong>{{ casualty.playlist }}</strong> ({{ casualty.when }}) does not reach the screen.
          </div>
          <div class="preflight-cause">{{ casualty.cause }}</div>
          <div class="jumbotron-note preflight-remedy">
            <i class="fas fa-wrench" aria-hidden="true"></i>
            <span>{{ casualty.remedy }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</dialog>
`;
// Exports
export default code;